interface Props {
  width?: string;
  height?: string;
}

const Stethoscope = ({ width = '25', height = '25' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M9.167 11.668a4.167 4.167 0 0 1-4.166-4.167V4.168a.833.833 0 0 1 .833-.833h.833a.833.833 0 0 0 0-1.667h-.833a2.5 2.5 0 0 0-2.5 2.5v3.333a5.817 5.817 0 0 0 2.517 4.784A7.334 7.334 0 0 1 8.334 17.5a5.834 5.834 0 0 0 11.667 0v-.95a3.333 3.333 0 1 0-1.667 0v.95a4.167 4.167 0 1 1-8.333 0 7.334 7.334 0 0 1 2.5-5.216A5.817 5.817 0 0 0 15 7.5V4.168a2.5 2.5 0 0 0-2.5-2.5h-.834a.833.833 0 1 0 0 1.667h.834a.833.833 0 0 1 .833.833v3.333a4.167 4.167 0 0 1-4.167 4.167zm10 3.333a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333z"
        fill="#4C3422"
      />
    </svg>
  );
};

export default Stethoscope;
